module.exports = __webpack_public_path__ + "media/9.238acd50.mp3";